import { BreadcrumbItem, Mtds } from 'prove-common'
import { Link } from 'react-router'
import { NotificationPopover } from '../notification-popover/NotificationPopover'

type TopBarProps = {
  logo?: React.ReactNode
  title?: string
  action?: React.ReactNode
  breadcrumbItems?: BreadcrumbItem[]
  showNotificationBell?: boolean
  isProvePlan?: boolean
}

// Tooltip text starting with '#' is interpreted as an element ID reference.
const getTooltipText = (label?: string) => label?.replace(/^#/, 'Prøve #')

export const TopBar = ({
  logo,
  title,
  action,
  breadcrumbItems,
  showNotificationBell = false,
  isProvePlan = true
}: TopBarProps) => {
  const prevItem =
    breadcrumbItems && breadcrumbItems.length > 1
      ? breadcrumbItems.at(-2)
      : undefined

  return (
    <Mtds.Flex
      data-justify='space-between'
      data-align='start'
      className='w-full'
    >
      <Mtds.Breadcrumbs>
        {prevItem?.to && (
          <Link
            to={prevItem.to}
            aria-label={'Tilbake til ' + prevItem.label}
            data-tooltip={getTooltipText(prevItem.label)}
          >
            {prevItem.label}
          </Link>
        )}
        <ol className={'items-center'}>
          <li className={'flex items-center'}>{logo}</li>
          {breadcrumbItems?.map((item, i, { length }) => (
            <li key={item.to ?? item.label ?? `breadcrumb-${i}`}>
              {item.to && i !== length - 1 ? (
                <Link to={item.to} data-tooltip={getTooltipText(item.label)}>
                  {item.label}
                </Link>
              ) : (
                <Mtds.Flex
                  as='strong'
                  data-align='center'
                  data-gap='1'
                  data-tooltip={getTooltipText(item.label)}
                  {...({ tabIndex: 0 } as Record<string, number>)}
                >
                  {!!item.icon && item.icon}
                  <span className='inline-block max-w-[16rem] truncate align-bottom'>
                    {item.label}
                  </span>
                </Mtds.Flex>
              )}
            </li>
          ))}
          {!!title && (
            <li>
              <strong data-tooltip={getTooltipText(title)} tabIndex={0}>
                <span className='inline-block max-w-[16rem] truncate align-bottom'>
                  {title}
                </span>
              </strong>
            </li>
          )}
        </ol>
      </Mtds.Breadcrumbs>
      {action}
      {showNotificationBell && (
        <NotificationPopover isProvePlan={isProvePlan} />
      )}
    </Mtds.Flex>
  )
}
